/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const societaSmtpConfigurationDtoSchema = z.object({
  societaId: z.coerce.number().int(),
  societaName: z.coerce.string(),
  isConfigured: z.boolean(),
  host: z.coerce.string().nullable().nullish(),
  port: z.coerce.number().int().nullable().nullish(),
  authEnabled: z.boolean().nullable().nullish(),
  username: z.coerce.string().nullable().nullish(),
  senderEmail: z.coerce.string().nullable().nullish(),
  senderName: z.coerce.string().nullable().nullish(),
  socketSecurity: z
    .enum(['auto', 'startTls', 'sslOnConnect', 'none'])
    .nullable()
    .nullish(),
  hasPassword: z.boolean(),
});
